import React, { Component } from "react";
import NumberFormat from "react-number-format";
import InputMoment from "input-moment";
import moment from "moment-timezone";

// Components
import SearchbarAjax from "./../../utils/SearchbarAjax";
import SearchPromotionCategories from "../../search/SearchPromotionCategories";
import DeleteConfirmationDialog from "../../utils/DeleteConfirmationDialog";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";

import { REACT_APP_API_URL } from "../../../shared/vars";

class PromotionFields extends Component {
	constructor(props) {
		super(props);
		this.state = {
			categoryPg: 1,
			showDeleteConfirmationDialog: false
		};
	}

	render() {
		const { item, errors, updateLoading, deletionInProgress, updateSuccess } = this.props;

		// item.sale_start = !!item.stasale_startrt ? item.sale_start : item.start
		// item.sale_end = !!item.sale_end ? item.sale_end : item.end

		return (
			<div className="fieldset">
				<div className="title-label">{!!item.id ? <span>Edit Promotion</span> : <span> New Promotion</span>}</div>

				<div className="form-field">
					<label>Title:</label>

					{!!errors.title && <div className="error msg_animate">{errors.title}</div>}
					<input type="text" value={!!item.title ? item.title : ""} maxLength="255" disabled={updateLoading || deletionInProgress} onKeyPress={e => this.props.handleKeyPress(e)} onChange={e => this.props.handleChange(e.target.value, "title")} />
				</div>

				<div className="floated-field-container">
					<div className="form-field half-field">
						<label>Amount:</label>

						{!!errors.value && <div className="error msg_animate">{errors.value}</div>}
						<NumberFormat value={!!item.value ? item.value : ""} placeholder="0.00" prefix={item.sale_type ? "$" : ""} suffix={!item.sale_type ? "%" : ""} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} disabled={updateLoading || deletionInProgress} onKeyPress={e => this.props.handleKeyPress(e)} onValueChange={e => this.props.handleChange(e.value, "value")} />
					</div>

					<div className="form-field half-field">
						<label>Type:</label>

						{!!errors.sale_type && <div className="error msg_animate">{errors.sale_type}</div>}
						<div className="item-price-type">
							<label className="tgl">
								<input type="checkbox" value="dollar" checked={!!item.sale_type} disabled={updateLoading || deletionInProgress} onChange={e => this.props.handleCheckboxClick("sale_type")} />
								<span data-on="$" data-off="%" />
							</label>
						</div>
					</div>
				</div>

				<div className="form-field">
					<label>Start</label>

					{!!errors.sale_start && <div className="error msg_animate">{errors.sale_start}</div>}
					<input
						type="text"
						className="readonly-clickable"
						placeholder="No start time set"
						maxLength="255"
						readOnly
						disabled={updateLoading || deletionInProgress}
						value={
							!!item.sale_start
								? moment
										.utc(item.sale_start)
										.local()
										.format("YYYY-MM-DD h:mma")
								: ""
						}
						onClick={() => this.setState({ showStartDialog: !this.state.showStartDialog })}
					/>
					{this.state.showStartDialog && <InputMoment className="top-margin" moment={!!item.sale_start ? moment(item.sale_start) : moment()} onChange={m => this.props.handleChange(m.format("YYYY-MM-DD H:mm"), "sale_start")} prevMonthIcon="icon-circle-left" nextMonthIcon="icon-circle-right" />}
				</div>

				<div className="form-field">
					<label>End</label>

					{!!errors.sale_end && <div className="error msg_animate">{errors.sale_end}</div>}
					<input
						type="text"
						className="readonly-clickable"
						placeholder="No end time set"
						maxLength="255"
						readOnly
						disabled={updateLoading || deletionInProgress}
						value={
							!!item.sale_end
								? moment
										.utc(item.sale_end)
										.local()
										.format("YYYY-MM-DD h:mma")
								: ""
						}
						onClick={() => this.setState({ showEndDialog: !this.state.showEndDialog })}
					/>
					{this.state.showEndDialog && <InputMoment className="top-margin" moment={!!item.sale_end ? moment(item.sale_end) : moment()} onChange={m => this.props.handleChange(m.format("YYYY-MM-DD H:mm"), "sale_end")} prevMonthIcon="icon-circle-left" nextMonthIcon="icon-circle-right" />}
				</div>

				<div className="form-field">
					<label>Description:</label>

					{!!errors.content && <div className="error msg_animate">{errors.content}</div>}

					{/* CKEditor */}
					<CKEditor scriptUrl="/ckeditor/ckeditor.js" content={!!item.content ? item.content : ""} config={{ filebrowserImageBrowseUrl: "/image-browser", filebrowserBrowseUrl: "/file-browser", uploadUrl: REACT_APP_API_URL + `files`, readOnly: this.props.updateLoading || this.props.deletionInProgress }} events={{ instanceReady: editorReady.bind(this), change: evt => this.props.handleChange(evt.editor.getData(), "content") }} />
				</div>

				<div className="floated-field-container">
					<div className="form-field">
						<label>Categories Included:</label>

						{!!errors.categories && <div className="error msg_animate">{errors.categories}</div>}
						<div className="selected-item-wrapper hbs-selected-category-items promo-category-selections hbs-search-form">
							<SearchbarAjax placeholder={"Search categories"} component={SearchPromotionCategories} searchEndpoint={"search/category-grouped"} userType="admin" pg={this.state.categoryPg} itemsIndex={"items"} params={{ show_children: 1 }} selectedPromotions={this.props.promotions} promotionItem={item} disabled={this.props.updateLoading || this.props.deletionInProgress} {...this.props} />
						</div>
					</div>
				</div>

				<div className="btn_container">
					{updateSuccess && <div className="success msg_animate">{updateSuccess}</div>}
					{!!errors.general && <div className="error msg_animate">{errors.general}</div>}
					<button className={"btn submit-btn" + (updateLoading ? " loading" : "")} onClick={() => this.props.submitItem()} disabled={updateLoading || deletionInProgress}>
						{item.id ? <span>Update</span> : <span>Create</span>}
					</button>
					{item.id && (
						<button className={"btn delete-btn" + (deletionInProgress ? " loading" : "")} onClick={() => this.setState({ showDeleteConfirmationDialog: true })} disabled={updateLoading || deletionInProgress}>
							<span>Delete</span>
						</button>
					)}

					<DeleteConfirmationDialog show={this.state.showDeleteConfirmationDialog} deletionInProgress={this.props.deletionInProgress} id={item.id} itemTitle={item.title} handleDelete={this.props.handleDelete} handleDeleteRedirect={this.props.handleDeleteRedirect} handleClose={() => this.setState({ showDeleteConfirmationDialog: false })} deleteErrors={this.props.deleteErrors} deleteSuccess={this.props.deleteSuccess} />
				</div>
			</div>
		);
	}
}

export default PromotionFields;



// WEBPACK FOOTER //
// ./src/components/admin/promotions/PromotionFields.js